<template>
  <dl class="away" :class="{'active': checkCart(bets)}" @click="addCart(bets, folder, game)">
    <dt>
      {{ team | teamName }}
    </dt>
    <dd>
      <span class="orange ib">{{ price }}</span>
      <span class="ib">
        <img v-if="bets.name === 'Under'" style="width: 9px; height: 8px; margin-top: -3px;" src="@/assets/img/ico/m_ico_down.png" alt="">
        <img v-if="folder.market.isHandicap === 'y' && folder.market.isOverUnder === 'n' && checkCart(bets)" style="width: 8px; margin-top: -3px;" src="@/assets/img/ico/white/h.png" alt="">
        <img v-if="folder.market.isHandicap === 'y' && folder.market.isOverUnder === 'n' && !checkCart(bets)" style="width: 8px; margin-top: -2px;" src="@/assets/img/ico/red/h.png" alt="">
        <span v-if="up || down" style="font-size: 8px; margin-left: 3px; margin-right: 3px;">
          {{ startPrice }}
        </span>
        <i v-if="up" class="ico-up blink"></i>
        <i v-if="down" class="ico-down blink"></i>
      </span>
    </dd>
  </dl>
</template>

<script>
export default {
  name: "Price",
  props: ['bets', 'folder', 'addCart', 'checkCart', 'game', 'team'],
  data: function(){
    return {
      startPrice: null,
      up: false,
      down: false
    }
  },
  computed: {
    price: function(){
      return Number(this.bets.price).toFixed(2)
    },
  },
  watch: {
    price: function(newVal, val){
      if (Number(newVal) - Number(val) < 0) this.down = true;
      if (Number(newVal) - Number(val) > 0) this.up = true;
      if (Number(newVal) !== Number(val)) this.startPrice = val;
    },
    up: function(){
      this.down = false;
      setTimeout(() => {
        this.up = false
        this.startPrice = null;
      } ,10000)
    },
    down: function(){
      this.up = false;
      setTimeout(() => {
        this.down = false
        this.startPrice = null;
      } ,10000)
    }
  },
}
</script>

<style scoped>
.blink {
  animation: top-arrow-down 1s 10!important;
}
.active span{
  color: #FFFFFF !important;
}
</style>
